import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react"; // FB 6739
import useStyles from "./css/styles";
import { Context } from "../create/store";
import globalsettings from "../../config";
//FB 4867 DK - Importing references
import { useHistory } from "react-router";
//FB-6264
//FB 7675
import { ConvertTimeZone, GetAdminSettingValue, GetLicenseName, InsertPELogs } from "./api"; // FB 4960  // FB 6739


// update log
// FB 4371 DK    03/29/2021    Added to display the appointment booking summary
// FB 4574 DK    07/15/2021    Removed "Dr." string from messages
// FB 4735 DK    10/11/2021    Implementation of provider specific flow
// FB 4867 DK    12/27/2021    Added screens for Support files and Health forms upload
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6109 DK    08/24/2022    Consent form integration changes
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 6739 GS    04/25/2023    Message on appointment confirmation screen
// FB 7675 DK    11/09/2023    Timezone handling for appointments
// FB 7719 SK    02/13/2024    PE- option to add credit card on file while booking an appointment
// FB 8259 SK    02/28/2024    After booking appt with card details when user click back button needs to be handled
// FB 10675 DK   06/10/2025    Landing page not working properly; Please identify yourself page should display before buttons


const cardstyles = makeStyles({
  subheader: {
    color: "white",
  },
});

export default function Confirmation() {
  const styles = useStyles();
  const cardstyle = cardstyles();
  const { state } = useContext(Context);
  const [textMessage, setTextMessage] = useState("");   // FB 6739

  let apptType = "1";
  if (state.appointmentdetails.appointmenttype === "telederm") {
    apptType = "2";
  }

  let patientName = state.patient.name;
  if (patientName !== "") {
    patientName = patientName.charAt(0).toUpperCase() + patientName.slice(1);
  }

  const dateOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
  };

  // FB 6739 Begin
  async function GetInofficeMessage() {
    setTextMessage(await GetAdminSettingValue("InOffice_Appointment_Message"));
  }

  useEffect(() => {
    GetInofficeMessage();
  }, []);
  // FB 6739  End
  

  // FB 4867 DK - Added button actions for File and Healthforms screen redirection - Start
  const history = useHistory();
  const handleSupportFilesUpload = () => {
    history.push("/upload", state);
  }
  //FB 8259 - Begin
  window.addEventListener('popstate', () => {
    history.push("/logout");
  });
  //FB 8259 - End
  const handleIntakeUpload = async () => {
    const appt_n = state.patient.appointment_n; //FB-6264
    window.open(globalsettings.emrAPI + "patient_intake/pi_login.asp?app_n=" + appt_n + "&np=1", "_blank");
  }
  const handleNextClick = async () => {
    // FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Next - Confirmation Page");
    // FB 4960 End
    sessionStorage.setItem("IsPatientVerified","Yes");  //FB 10675
    //FB-6264
    // FB 7719 Begin
    let appt_n = state.patient.appointment_n;
    if(!appt_n){
      appt_n=sessionStorage.getItem("prev_appN");
    }
    // FB 7719 End
    var encodedAppt_n = Buffer.from(appt_n.toString()).toString('base64');
    let licensename = await GetLicenseName();
    licensename = licensename[0].replace(' ', '+');
    history.push("/appointments/landingPage/" + encodedAppt_n + "/" + licensename + "/0", state);
  }

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  // FB 4867 DK - Added button actions for File and Healthforms screen redirection - End

  //FB 7675
  var timeZone = "America/Port-au-Prince";
  var userTimeZone = sessionStorage.getItem("TimeZone");
  if (userTimeZone != null) {
    timeZone = userTimeZone;
  }

  var convertedSlot = ConvertTimeZone(state.slotDetails.slotDate.toDateString(), state.slotDetails.slotDate.toTimeString(), timeZone, "datetime");

  return (
    <div>
      <section
        ref={scrollTo}   //FB 4867
        style={{
          margin: "10px 20px 20px",
        }}
      >
        {/* FB 4867 DK - Styling changes */}
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*FB 4574 DK - Removed uneccesary syntax*/}
            <Typography
              variant={window.innerWidth < 768 ? "subtitle1" : "h5"}
              style={{ color: "limegreen" }}
            >
              Your Appointment has been Booked!
            </Typography>
          </Grid>
        </Grid>
        {/* FB 4867 DK - Styling changes */}
        <Grid container style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Grid
            item
            xs={11}
          >
            {/* FB 4867 DK - Styling changes */}
            <Typography
              variant="h6"
              style={{
                display:
                  state.appointmentdetails.appointmenttype === "inoffice"
                    ? "flex"
                    : "none",
              }}
            >
              <p>
                {"Hi " + patientName + ","}
                <br />
                {"Your appointment has been booked with"}{" "}
                <b>
                  {" "}
                  {/* FB 4574 DK - Removed "Dr." string from messages */}
                  {/* FB 7675 */}
                  {
                    state.slotDetails.employeeName +
                    " on " +
                    new Date(convertedSlot).toLocaleString('en-US', dateOptions) +
                    " at " +
                    state.slotDetails.facilityName}
                </b>
              </p>
            </Typography>
            {/* FB 4867 DK - Styling changes */}
            <Typography
              variant="h6"
              style={{
                display:
                  state.appointmentdetails.appointmenttype === "telederm"
                    ? "flex"
                    : "none",
              }}
            >
              <p>
                {"Hi " + patientName + ","}
                <br />
                {"Your appointment has been booked with"}{" "}
                <b>
                  {" "}
                  {/* FB 4574 DK - Removed "Dr." string from messages */}
                  {/* FB 7675 */}
                  {
                    state.slotDetails.employeeName +
                    " on " +
                    new Date(convertedSlot).toLocaleString('en-US', dateOptions)}
                </b>
              </p>
            </Typography>
          </Grid>
          {/* FB 4867 DK - Button to proceed to landing page */}
          <Grid item xs={9} spacing={1}>
            <Typography style={{ fontSize: "1.05rem" }}>
              To speed up your appointment, Please click on the Next button to fill out the Health Forms and upload any Supporting Documents
            </Typography>
          </Grid>
          <Grid item xs={2} spacing={1}>
            <Button
              variant="contained"
              className={styles.navigationButton}
              onClick={handleNextClick}
              style={{ marginLeft: 10 }}
            >
              Next
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "1%",
            }}
          >
            <Card
              style={{
                display: "flex",
                flexDirection: "column",
                width: "400px",
              }}
            >
              <CardHeader
                classes={{
                  subheader: cardstyle.subheader,
                }}
                style={{
                  backgroundColor: "#2FABBF",
                  color: "white",
                }}
                title="Appointment Time:"
                //FB 7675
                subheader={
                  new Date(convertedSlot).toLocaleDateString() +
                  " at " +
                  new Date(convertedSlot).toLocaleString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                }
              />
              <CardContent>
                {/* FB 4867 DK - Styling changes */}
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  {/* FB 4574 DK - Removed "Dr." string from messages */}
                  {state.slotDetails.employeeName}
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    display:
                      state.appointmentdetails.appointmenttype === "telederm"
                        ? "none"
                        : "flex",
                  }}
                >
                  {state.appointmentdetails.location.name === null ||
                    state.appointmentdetails.location.name === undefined
                    ? ""
                    : state.appointmentdetails.location.name + ", "}
                  <br />
                  {state.appointmentdetails.location.address === null ||
                    state.appointmentdetails.location.address === undefined
                    ? ""
                    : state.appointmentdetails.location.address}
                  <br />
                  {state.appointmentdetails.location.phone === null ||
                    state.appointmentdetails.location.phone === undefined
                    ? ""
                    : state.appointmentdetails.location.phone}
                </Typography>
                <hr />
                {/* FB 4867 DK - Styling changes */}
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  {state.appointmentdetails.appointmenttype === "telederm"
                    ? globalsettings.digitalApptType + " Appointment"
                    : "In-office Appointment"}
                </Typography>
                {/* FB 6109 */}
                <Typography variant="body2">
                  {state.appointmentdetails.appointmenttype === "inoffice" ? textMessage : "You will receive an email with a link to join a TeleHealth Appointment. Please use the link to join a meeting 5 minutes prior to your appointment time. For a better video visit experience, we recommend that you connect to Wi-Fi/high-speed internet connection and limit your data usage. For privacy purposes, you should be in a private place during your visit and should use headphones or a headset to avoid having someone overhearing your conversation."} {/* FB 6739 */}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* FB 4867 DK - Removed unused code */}
      </section>
    </div>
  );
}
